function Home() {
    return (
        <div className="container text-center py-5">
            <h1>Welcome to Affiliate++</h1>
        </div>
    );
}

export default Home;